<template>
  <div class="content pr-2">
    <div v-html="rulesHtml"/>
    <div
      class="div-table"
      style="margin-top: .75rem;"
    >
      <div class="columns is-gapless">
        <div class="column is-12 has-text-centered">
          <strong>Points Calculator</strong>
        </div>
      </div>
      <div class="columns is-gapless">
        <div class="column is-7">
          <strong>Number of Entrants:</strong>
          <div class="field has-addons is-pulled-right">
            <div class="control">
              <input
                v-model="numberOfPlayers"
                class="input is-small"
                type="text"
                placeholder="Points"
              >
            </div>
          </div>
          <div class="is-clearfix" />
        </div>
        <div class="column is-5 has-text-right">
          <span class="tag is-info">PL</span>
          <strong>= Number of players</strong>
        </div>
      </div>
      <div class="columns is-gapless is-flex">
        <div class="column is-3 has-text-centered">
          <strong class="is-size-7-touch">Place</strong>
        </div>
        <div class="column is-3 has-text-centered">
          <strong class="is-size-7-touch">Base</strong>
        </div>
        <div class="column is-3 has-text-centered">
          <strong class="is-size-7-touch">Additional</strong>
        </div>
        <div class="column is-3 has-text-centered">
          <strong class="is-size-7-touch">Example</strong>
        </div>
      </div>
      <div
        v-for="item in items"
        class="columns is-gapless is-flex"
      >
        <div class="column is-3 has-text-centered-touch has-text-right-tablet">
          <strong class="is-size-7-touch">{{ item.place }}</strong>
        </div>

        <div class="column is-3 has-text-centered has-text-right-tablet">
          <span class="is-size-7-touch">{{ item.base }}</span>
        </div>

        <div class="column is-3 has-text-centered has-text-right-tablet">
          <span class="is-size-7-touch">{{ item.multiple }}x <span class="tag is-info">PL</span></span>
        </div>

        <div class="column is-3 has-text-centered has-text-right-tablet">
          <span class="is-size-7-touch">{{ item.base }} + ({{ item.multiple }} * {{ inputValidation }}) 	{{ pointCalculator(item.base, item.multiple) }}</span>
        </div>
      </div>
    </div>
    <br>
    <p>
      <strong>Tracking your points</strong><br>
      AHL Tournament Directors do not keep player points or statistics with them. Players can only track their points using the AHL Poker Online System. A "Qualified List" will be available at any AHL event where players must qualify to play. For any AHL points errors or questions please contact us at <a href="#">points@ahlpoker.com</a>
    </p>
    <p>
      <strong>Online Player Stats / Points System</strong><br>
      Members can track their points and statistics using the AHL's Online System. The online system allows members to track their friends and other competitors online. Members can see their points by month, year, or since they have registered. They may also see points by region, state or venue. This gives the member the ability to track stats in a variety of ways to see how they are progressing as a player.
    </p>
  </div>
</template>

<script>
  export default {
    name: '',
    props:['rulesHtml'],
    data () {
      return {
        numberOfPlayers: 64,
        items: [
          {
            place: '1st',
            base: 560,
            multiple: 1
          },
          {
            place: '2nd',
            base: 360,
            multiple: 1
          },
          {
            place: '3rd',
            base: 250,
            multiple: 1
          },
          {
            place: '4th',
            base: 210,
            multiple: 1
          },
          {
            place: '5th',
            base: 180,
            multiple: 1
          },
          {
            place: '6th',
            base: 160,
            multiple: 1
          },
          {
            place: '7th',
            base: 140,
            multiple: 1
          },
          {
            place: '8th',
            base: 100,
            multiple: 1
          },
          {
            place: '9th',
            base: 30,
            multiple: 1
          },
          {
            place: '10th',
            base: 30,
            multiple: 0.9
          },
          {
            place: '11th',
            base: 30,
            multiple: 0.8
          },
          {
            place: '12th',
            base: 30,
            multiple: 0.7
          },
          {
            place: '13th',
            base: 30,
            multiple: 0.6
          },
          {
            place: '14th',
            base: 30,
            multiple: 0.5
          },
          {
            place: '15th',
            base: 30,
            multiple: 0.4
          },
          {
            place: '16th',
            base: 30,
            multiple: 0.3
          }
        ]
      }
    },
    computed: {
      inputValidation () {
        let players = +this.numberOfPlayers
        if (this.numberOfPlayers <= 0 || isNaN(this.numberOfPlayers)) {
          return 64
        } else {
          return players.toFixed(0)
        }
      }
    },
    methods: {
      pointCalculator (base, multiple) {
        return (+base + (+multiple * this.inputValidation)).toFixed(0)
      }
    }
  }
</script>